import React, { FC } from 'react';

import { useStore } from 'kioskApp/hooks';
import { CustomIconProps } from 'shared/interfaces/CustomIconProps';

export const NextIcon: FC<CustomIconProps> = ({ colorType }) => {
    const { configuration } = useStore();
    const theme = configuration.theme;

    const fillColor =
        colorType === 'primary'
            ? theme.primaryButton.fontColor
            : theme.secondaryButton.fontColor;

    return (
        <svg
            fill={fillColor}
            width='24'
            height='25'
            viewBox='0 0 24 25'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M14.3769 15.5066L2.71643 15.5066C2.00104 15.472 1.32431 15.1544 0.821145 14.6175C0.317979 14.0805 0.02534 13.3635 0.00157057 12.6093C-0.0222008 11.8552 0.224644 11.1193 0.692891 10.5484C1.16114 9.97744 1.81639 9.61338 2.52803 9.52882C4.49587 9.52882 6.46371 9.52882 8.43156 9.52882L14.3979 9.52882L14.1676 9.26413C12.8697 7.87448 11.5508 6.50687 10.2738 5.11722C9.92335 4.74305 9.67238 4.27836 9.54602 3.76982C9.41965 3.26129 9.42233 2.72678 9.55378 2.21968C9.68523 1.71257 9.94083 1.25075 10.295 0.880498C10.6492 0.510251 11.0894 0.244518 11.5717 0.110004C12.0491 -0.0358819 12.5559 -0.036683 13.0337 0.107715C13.5115 0.25211 13.9409 0.535817 14.2723 0.926139C16.8472 3.63928 19.4012 6.37452 21.9762 9.10971L23.1485 10.367C23.4181 10.6462 23.6323 10.9793 23.7785 11.3466C23.9247 11.714 24 12.1083 24 12.5066C24 12.9049 23.9247 13.2994 23.7785 13.6667C23.6323 14.0341 23.4181 14.3671 23.1485 14.6463L14.2723 24.1091C13.9173 24.4922 13.4702 24.7666 12.9787 24.9028C12.4873 25.039 11.9699 25.0319 11.482 24.8825C10.994 24.733 10.5538 24.4467 10.2082 24.0541C9.86269 23.6615 9.62487 23.1773 9.52014 22.6534C9.40071 22.1629 9.40968 21.6476 9.54607 21.1621C9.68246 20.6765 9.94118 20.239 10.2947 19.8961C11.5717 18.5065 12.8906 17.1168 14.1885 15.7271L14.3769 15.5066Z' />
        </svg>
    );
};
